const PRODUCT_BASE_PATH = "/p/"

function getProductLink(slug) {
  return PRODUCT_BASE_PATH + slug
}

module.exports = {
  getProductLink: getProductLink,
}
